'use strict'

export function groupItems (items) {
  const segmentItems = items.filter(material => material.isSegment)
  const notSegmentItems = items.filter(material => !material.isSegment)

  const itemsToShow = []

  segmentItems.forEach((item) => {
    const index = indexOfSimilarItem(item, items)
    if (index !== -1) {
      const similarItem = items[index]
      similarItem.amount += item.amount
    } else {
      itemsToShow.push(item)
    }
  })

  notSegmentItems.forEach((item) => {
    itemsToShow.push(item)
  })

  return itemsToShow
}

function indexOfSimilarItem (item, items) {
  const copyItemWithoutAmount = JSON.parse(JSON.stringify(item))
  delete copyItemWithoutAmount.amount
  delete copyItemWithoutAmount.recId
  delete copyItemWithoutAmount.mountingId
  delete copyItemWithoutAmount.demountingId
  delete copyItemWithoutAmount.note
  delete copyItemWithoutAmount.noted
  delete copyItemWithoutAmount.reportId
  delete copyItemWithoutAmount.requestId
  delete copyItemWithoutAmount.changed
  delete copyItemWithoutAmount.isSegment

  const copyItemsWithoutAmount = JSON.parse(JSON.stringify(items))
  copyItemsWithoutAmount.forEach((item) => {
    delete item.amount
    delete item.recId
    delete item.mountingId
    delete item.demountingId
    delete item.note
    delete item.noted
    delete item.reportId
    delete item.requestId
    delete item.changed
    delete item.isSegment
  })

  return copyItemsWithoutAmount.indexOf(copyItemWithoutAmount)
}

export function formatRecId (value, items) {
  if (value) {
    const index = items.map(item => item.recId).indexOf(value)
    if (index !== -1) {
      return items[index].toolName
    } else {
      return value
    }
  } else {
    return ''
  }
}

export function formatTrueFalse (value) {
  if (value === true) {
    return 'Да'
  } else if (value === false) {
    return 'Нет'
  } else {
    return 'Нет значения'
  }
}

const sourceTables = [
  { key: 'debit', name: 'Списание с мобильного склада' },
  { key: 'consumption', name: 'Расход вне склада' },
  { key: 'demounting', name: 'Списание со склада демонтажа' },
  { key: 'other', name: 'Другое' }
]

export function formatSource (key) {
  let name = ''
  for (let i = 0; i < sourceTables.length; i++) {
    if (key === sourceTables[i].key) {
      name = sourceTables[i].name
      break
    } else {
      name = 'Не выбран'
    }
  }
  return name
}

export function getTagByKey (tagKey, tags) {
  const tag = tags.find(t => t.key === tagKey)
  return tag || null
}

export function setPreciseAmount (item) {
  if (item.amount) {
    this.$set(item, 'amount', Math.round(item.amount * 1000) / 1000)
  } else {
    this.$set(item, 'amount', null)
  }
}

export function canDeleteSegment (materialsSourceReport, tableName) {
  if (!tableName) {
    return true
  }
  const report = materialsSourceReport._multiReport || materialsSourceReport
  const workTypeKey = tableName === 'demountings_table' ? 'cableDemountW' : 'cableMountW'
  const workType = findReportWorkType(report, workTypeKey)
  // if (workType && workType.technologicalOperations) {
  //   for (const technologicalOperation of workType.technologicalOperations) {
  //     if (technologicalOperationHasResult(technologicalOperation, report, workType)) {
  //       return false
  //     }
  //   }
  // }
  // TODO проверить наличие результата работы по текущему отчёту
  return workType == null
}

function findReportWorkType (report, workTypeKey) {
  let workType = findWorkType(report.workTypes, workTypeKey)
  if (!workType && report.workPackages && report.workPackages.length) {
    for (const workPackage of report.workPackages) {
      workType = findWorkType(workPackage.workTypes, workTypeKey)
      if (workType) {
        break
      }
    }
  }
  return workType
}

function findWorkType (workTypes, workTypeKey) {
  if (workTypes && workTypes.length) {
    return workTypes.find(workType => workType.key === workTypeKey)
  }
  return null
}

function getReportWorkKeys (report) {
  const workKeys = []
  if (report.workTypes && report.workTypes.length) {
    report.workTypes.forEach(workType => {
      workKeys.push(workType.key)
    })
  }
  if (report.workPackages && report.workPackages.length) {
    report.workPackages.forEach(workPackage => {
      if (workPackage.workTypes && workPackage.workTypes.length) {
        workPackage.workTypes.forEach(workType => {
          workKeys.push(workType.key)
        })
      }
    })
  }
  return workKeys
}

export function flattenStandardSpecificationItems (standardSpecificationsByReport) {
  const result = []
  if (!standardSpecificationsByReport) {
    return result
  }
  Object.keys(standardSpecificationsByReport).forEach(reportId => {
    const items = standardSpecificationsByReport[reportId] || []
    items.forEach(item => {
      result.push({
        reportId: Number(reportId) || reportId,
        tool: item.tool,
        standard: item.standard || { count: null, project: null }
      })
    })
  })
  return result
}

export function buildAvailableMaterialsTableItems (materialesAvailable, standardSpecificationsByReport) {
  const flatSpecs = flattenStandardSpecificationItems(standardSpecificationsByReport)
  const specsByToolKey = {}
  flatSpecs.forEach(entry => {
    if (!entry.tool || !entry.tool.key) {
      return
    }
    const key = entry.tool.key
    if (!specsByToolKey[key]) {
      specsByToolKey[key] = []
    }
    specsByToolKey[key].push({
      reportId: entry.reportId,
      count: entry.standard.count,
      project: entry.standard.project,
      tool: entry.tool
    })
  })

  const usedToolKeys = {}
  const rows = (materialesAvailable || []).map(material => {
    const standards = specsByToolKey[material.toolKey] || []
    if (material.toolKey) {
      usedToolKeys[material.toolKey] = true
    }
    return Object.assign({}, material, {
      standards: standards,
      outOfStock: false
    })
  })

  Object.keys(specsByToolKey).forEach(toolKey => {
    if (usedToolKeys[toolKey]) {
      return
    }
    const standards = specsByToolKey[toolKey]
    const tool = standards[0].tool
    rows.push({
      toolKey: tool.key,
      toolName: tool.name,
      unit: tool.unit,
      unit2: tool.unit2,
      maxUnit2: tool.maxUnit2,
      hasLoops: false,
      amount: [],
      stockKey: [],
      stockName: [],
      stockId: [],
      isArchive: [],
      reserve: [],
      block: [],
      standards: standards,
      outOfStock: true
    })
  })

  return rows
}

export function buildSpecificationMaterials (standardSpecification, materialesAvailableWithAmount, materialesAvailable) {
  const stockByKey = {}
  materialesAvailableWithAmount.forEach(m => {
    stockByKey[m.toolKey] = m
  })
  const allStockByKey = {}
  materialesAvailable.forEach(m => {
    allStockByKey[m.toolKey] = m
  })

  return (standardSpecification || []).map(item => {
    const tool = item.tool || {}
    const standard = item.standard || { count: null, project: null }
    const stock = stockByKey[tool.key]
    if (stock) {
      return Object.assign({}, stock, {
        standard: standard,
        outOfStock: false
      })
    }
    const stockAny = allStockByKey[tool.key]
    return {
      toolKey: tool.key,
      toolName: tool.name,
      unit: tool.unit || (stockAny && stockAny.unit) || null,
      unit2: tool.unit2 || (stockAny && stockAny.unit2) || null,
      maxUnit2: tool.maxUnit2 != null ? tool.maxUnit2 : (stockAny && stockAny.maxUnit2),
      hasLoops: !!(stockAny && stockAny.hasLoops),
      amount: [],
      stockKey: [],
      stockName: [],
      stockId: [],
      isArchive: [],
      standard: standard,
      outOfStock: true
    }
  }).filter(m => m.toolKey)
}
